export const OPEN_SYNC_PROGRESS_EVENT = 'lidea-open-sync-progress';

export function openSyncProgressModal(): void {
  window.dispatchEvent(new Event(OPEN_SYNC_PROGRESS_EVENT));
}
